module.exports = __webpack_public_path__ + "img/magento-modules-customization@2x.0189acba.jpeg";